import { useState, useEffect, useRef, useCallback } from 'react';
import { getBloqueioProduto, getBloqueioProdutoDevolucao } from '../../services/api';

export const useBloqueioProduto = ({ ativo, devolucaoId, produtoId, vendaId, produtoEstoqueId }) => {
    const [bloqueio, setBloqueio] = useState(null);
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState(false);
    const [desbloquear, setDesbloquear] = useState(false);
    const consultaRef = useRef(0);

    const consultar = useCallback(async () => {
        if (!devolucaoId && !produtoId) return;
        const consulta = ++consultaRef.current;
        setCarregando(true);
        setErro(false);
        const res = devolucaoId
            ? await getBloqueioProdutoDevolucao(devolucaoId)
            : await getBloqueioProduto(produtoId, vendaId && produtoEstoqueId ? { venda_id: vendaId, produto_estoque_id: produtoEstoqueId } : {});
        if (consulta !== consultaRef.current) return;
        if (res?.error || typeof res?.bloqueado !== 'boolean') {
            setBloqueio(null);
            setErro(true);
            setDesbloquear(false);
        } else {
            setBloqueio(res);
            setDesbloquear(!!res.desbloquear_sugerido);
        }
        setCarregando(false);
    }, [devolucaoId, produtoId, vendaId, produtoEstoqueId]);

    useEffect(() => {
        if (ativo) {
            consultar();
            return;
        }
        consultaRef.current++;
        setBloqueio(null);
        setErro(false);
        setCarregando(false);
        setDesbloquear(false);
    }, [ativo, consultar]);

    return {
        bloqueio,
        carregando,
        erro,
        desbloquear,
        setDesbloquear,
        consultar,
        desbloquearEscolhido: !!(bloqueio?.bloqueado && desbloquear),
    };
};
